export const INITIAL_FILTERS = {
  user_id: "",
  action: "",
  start_date: "",
  end_date: "",
  search: "",
};

export const LIMIT = 10;

export const ACTION_LABELS = {
  purchased: "Purchased",
  extended: "Extended",
  cancelled: "Cancelled",
};
